import { Widget } from '@typeform/embed-react'
import React from 'react'
import { ampli } from 'src/ampli'
export interface TypeFormProps {
  data: {
    url: string
    width: string
    height: string
    background: string
  }
}

export const TypeForm = ({ data }: TypeFormProps) => {
  const typeformId = data.url.match(/\/([^\/]+)$/)?.[1]

  if (typeof window !== 'undefined') {
    return (
      <div
        style={{
          backgroundColor: data.background,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        { typeformId && 
            <Widget 
              style={
                { 
                  width: data.width, 
                  height: data.height
                }
              } 
              onSubmit={() => ampli.typeformSubmitted({ typeformId })} 
              id={typeformId}  
              className="typeform-widget" /> 
        }  
      </div>
    )
  } else {
    return <></>
  }
}
export default TypeForm
